
import { createContext } from 'react';
import { AuthContextType } from './constants';

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
